module.exports = __webpack_public_path__ + "img/go_rush.73db554.png";